import 'mdn-polyfills/Node.prototype.remove';
import 'mdn-polyfills/NodeList.prototype.forEach';
import Switch from "../switch/Switch";
import { debounce } from '../../utilities/utilities';

export default class Locator {
  constructor(element) {
    this.element = element;
    this.lat = this.element.querySelector('[data-locator-lat]');
    this.lng = this.element.querySelector('[data-locator-lng]');
    this.form = this.element.querySelector('[data-locator-form]');
    this.input = this.element.querySelector('[data-locator-input]');
    this.items = this.element.querySelectorAll('[data-locator-item]');
    this.geolocator = this.element.querySelector('[data-locator-geolocator]');
    this.mapElement = this.element.querySelector('[data-locator-map]');
    this.switchElement = this.element.querySelector('[data-locator-switch]');
    this.popupTemplate = document.getElementById('popup-template');
    this.tmp = 0;
    this.switch = null;
    this.leaflet = null;
    this.map = null;
    this.autocomplete = null;
    this.geocoder = null;
    this.pac = null;
    this.leafletIsLoading = false;
    this.leafletIsLoaded = false;
    this.gMapsIsLoading = false;
    this.gMapsIsLoaded = false;
    this.markers = [];
    this.featureGroup = null;

    this.handleAutocompleteChanged = this.handleAutocompleteChanged.bind(this);
    this.handleInputKeydown = this.handleInputKeydown.bind(this);
    this.handleDebouncedResize = debounce(this.handleDebouncedResize.bind(this), 100);
    this.handleGeolocalisationClick = this.handleGeolocalisationClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSwitchUpdate = this.handleSwitchUpdate.bind(this);
  }

  addMarker(item) {
    const lat = item.lat;
    const lng = item.lng;
    const theme = item.theme;
    const icon = this.leaflet.divIcon({
      className: `u-color-${ theme }`,
      html: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="32" height="32"><use xlink:href="/app/themes/default/assets/images/sprite.svg#sprite-marker"></use></svg>`,
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    });

    const marker = this.leaflet.marker([lat, lng], { icon: icon });

    this.markers.push(marker);

    if (this.popupTemplate) {
      let template = this.popupTemplate.innerHTML;
      template = template.replace(/{title}/, item.title);
      template = template.replace(/{address}/, item.address);
      template = template.replace(/{openings}/, item.openings);
      template = template.replace(/{tel}/, item.tel);
      template = template.replace(/{phone}/, item.phone);
      template = template.replace(/{button}/, item.button);
      template = template.replace(/{link}/, item.link);

      const popup = this.leaflet.popup({ className: `u-theme-${theme}` });
      popup.setContent(template);

      marker
        .bindPopup(popup)
        .addEventListener('popupopen', this.handlePopupOpen)
        .addEventListener('popupclose', this.handlePopupClose);
    }
  }

  handleAutocompleteChanged() {
    const place = this.autocomplete.getPlace();

    if (place.geometry) {
      this.lat.value = place.geometry.location.lat();
      this.lng.value = place.geometry.location.lng();
    }
  }

  handleDebouncedResize() {
    if (this.tmp !== this.element.offsetWidth) {

      if (this.switch) {
        const isDisplayed = window.getComputedStyle(this.switch.element).getPropertyValue('display') !== 'none';

        if (!isDisplayed && this.switch.mounted) {
          this.switch.unmount();
        } else if (isDisplayed && !this.switch.mounted) {
          this.switch.mount();
        }
      }

      this.tmp = this.element.offsetWidth;
    }
  }

  handleGeolocalisationClick(e) {
    this.geolocator.setAttribute('disabled', '');
    navigator.geolocation.getCurrentPosition((position) => {
      this.lat.value = position.coords.latitude;
      this.lng.value = position.coords.longitude;
      this.input.value = 'Ma position actuelle';
      this.geolocator.removeAttribute('disabled');
    }, (error) => {
        this.geolocator.removeEventListener('click', this.handleGeolocalisationClick);
        this.geolocator.remove();
    });
  }

  handleInputKeydown(e) {
    if (e.key === 'Enter' && this.input.value !== '') {
      e.preventDefault();
      this.geocoder.geocode({
        address: this.input.value,
        language: 'fr',
        region: 'fr'
      }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const firstResult = results[0];
          this.input.value = firstResult.formatted_address;
          this.lat.value = firstResult.geometry.location.lat();
          this.lng.value = firstResult.geometry.location.lng();
          this.form.submit();
        } else {
          alert(this.form.dataset.locatorError);
        }
      });
    } else {
      this.lat.value = '';
      this.lng.value = '';
    }
  }

  handleMap() {
    const is_patrimoine = document.getElementsByTagName('body')[0].classList.contains('u-theme-alteor-patrimoine');
    this.map = this.leaflet.map(this.mapElement, {
      center: is_patrimoine ? [48.2024, -2.8] : [47, 2],
      zoom: is_patrimoine ? 8 : 6
    });

    // const layerUrl = 'https://api.maptiler.com/maps/basic/256/{z}/{x}/{y}@2x.png?key=dSl9xUo8KormPT5EcrYw';
    // const layerUrl = 'https://api.maptiler.com/maps/basic/256/{z}/{x}/{y}@2x.png?key=STsuZZowjpQHyrgL4zoN';
    const layerUrl = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

    this.leaflet.tileLayer(layerUrl, {
      maxZoom: 20,
      referrerPolicy: 'no-referrer-when-downgrade'
    }).addTo(this.map);

    if (window.markers) {
      window.markers.forEach((item) => {
        this.addMarker(item);
      });

      this.featureGroup = this.leaflet.featureGroup(this.markers);

      this.clusterGroup = this.leaflet.markerClusterGroup({ showCoverageOnHover: false });
      this.clusterGroup.addLayer(this.featureGroup);
      this.clusterGroup.addTo(this.map);

      if (this.lat.value && this.lng.value) {
        this.map.fitBounds(this.featureGroup.getBounds(), { padding: [30, 30], maxZoom: 10 });
      }
    }
  }

  handlePopupOpen(e) {
    e.target['_icon'].classList.add('is-active');
  }

  handlePopupClose(e) {
    e.target['_icon'].classList.remove('is-active');
  }

  handleSubmit(e) {
    if (this.input.value !== '' && (!this.lat.value || !this.lng.value)) {
      e.preventDefault();
    }
  }

  handleSwitchUpdate(e) {
    if (this.map) {
      this.map.invalidateSize(true);
    }
  }

  initAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(this.input, { types: ['geocode'], componentRestrictions: { country: 'fr' } });
    this.geocoder = new google.maps.Geocoder();
    this.input.addEventListener('keydown', this.handleInputKeydown);
    this.autocomplete.addListener('place_changed', this.handleAutocompleteChanged);
  }

  loadGMaps() {
    if (!this.gMapsIsLoading && !this.gMapsIsLoaded && typeof window.google === 'undefined') {
      this.gMapsIsLoading = true;

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + googleMapsKey + '&libraries=places';
      script.addEventListener('load', () => {
        this.gMapsIsLoading = false;
        this.gMapsIsLoaded = true;
        this.initAutocomplete();
      }, { once: true });
      document.body.appendChild(script);
    }
  }

  loadLeaflet() {
    if (!this.leafIsLoading && !this.leafIsLoaded && typeof L === 'undefined') {
      this.leafIsLoading = true;

      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      document.body.appendChild(link);

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
      script.addEventListener('load', () => {
        this.leafIsLoading = false;
        this.leafIsLoaded = true;
        this.leaflet = window.L;
        this.loadClusterer();
      }, { once: true });
      document.body.appendChild(script);
    }
  }

  loadClusterer() {
    if (!this.clustererIsLoading && !this.clustererIsLoaded && typeof this.leaflet !== 'undefined') {
      this.clustererIsLoading = true;

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://unpkg.com/leaflet.markercluster@1.4.1/dist/leaflet.markercluster.js';
      script.addEventListener('load', () => {
        this.clustererIsLoading = false;
        this.clustererIsLoaded = true;
        this.handleMap();
      }, { once: true });
      document.body.appendChild(script);
    }
  }

  mount() {
    if ("geolocation" in navigator && "permissions" in navigator && this.geolocator) {
      navigator.permissions
        .query({ name: 'geolocation' })
        .then((result) => {
          if (result.state === "denied") {
            this.geolocator.remove();
          } else {
            this.geolocator.removeAttribute('hidden');
            this.geolocator.addEventListener('click', this.handleGeolocalisationClick);
          }
        });
    } else {
      this.geolocator.remove();
    }

    if (this.mapElement) {
      this.loadLeaflet();
    }

    if (this.form && this.input) {
      this.loadGMaps();
      this.form.addEventListener('submit', this.handleSubmit);
    }

    if (this.switchElement) {
      this.switch = new Switch(this.switchElement);
      this.switch.mount();
      this.switch.element.addEventListener('switch:toggle', this.handleSwitchUpdate);
      this.switch.element.addEventListener('switch:mounted', this.handleSwitchUpdate);
      this.switch.element.addEventListener('switch:unmounted', this.handleSwitchUpdate);
      window.addEventListener('resize', this.handleDebouncedResize);
      this.handleDebouncedResize();
    }
  }

  unmount() {
    if ("geolocation" in navigator && this.geolocator) {
      this.geolocator.removeEventListener('click', this.handleGeolocalisationClick);
    }

    this.map.remove();
    this.map = null;

    if (this.form && this.input) {
      this.form.removeEventListener('submit', this.handleSubmit);
    }

    if (this.autocomplete) {
      this.input.removeEventListener('change', this.handleInputKeydown);
    }

    if (this.switch) {
      this.switch.element.removeEventListener('switch:toggle', this.handleSwitchUpdate);
      this.switch.element.removeEventListener('switch:mounted', this.handleSwitchUpdate);
      this.switch.element.removeEventListener('switch:unmounted', this.handleSwitchUpdate);
      window.removeEventListener('resize', this.handleDebouncedResize);
      this.switch.unmount();
    }
  }
}
